import { useState } from 'react';
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useWindowSize } from '../../../hooks';
import config from '../../../config';
import {
  ideaCreateActions,
  multiAreaCascadeActions,
  ideaCreateDialogsActions,
  fluxOfIdeasActions,
} from '../../../actions';

export function useCreateIdeaController() {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [width] = useWindowSize();
  const location = useLocation();
  const [loadingCreateIdea, setLoadingCreateIdea] = useState(false);
  const ideaCreate = useSelector((state) => state.ideaCreate);
  const { loadingFlux, paging } = useSelector(state => state.fluxIdeas);
  const { fields } = useSelector(state => state.multiAreaCascade);
  const { ideasStepsFlux } = useSelector(state => state.domains);
  const { dialogSendIdea, fromHistory } = useSelector((state) => state.ideaCreateDialogs);
  const isSendIdeaDialog = fromHistory[fromHistory.length -1] === 'sendIdea';

  const unMaskCurrency = (value) => {
    return value?.replace(/[^\d,]/g, "").replace(",", ".");
  }

  async function createIdea() {
    try {
      setLoadingCreateIdea(true);

      if (ideaCreate?.challenge?.notChallenge) {
        delete ideaCreate.challenge;
      }

      await dispatch(fluxOfIdeasActions.createIdeaInFlux({
        ...ideaCreate,
        businessUnitLocal: fields.map(field => field.selectedBusinessUnit),
        estimatedFinancialReturn: unMaskCurrency(ideaCreate?.estimatedFinancialReturn),
        estimatedExecutionCost: unMaskCurrency(ideaCreate?.estimatedExecutionCost)
      }, t('sua_ideia_foi_enviada')));

      dispatch(ideaCreateActions.clearAll());
      dispatch(ideaCreateActions.clearClassification());

      if (location.pathname.includes('general')) {
        dispatch(fluxOfIdeasActions.getIdeaInFlux(id));
      } else if (location.pathname.includes('my-ideas')) {
        dispatch(fluxOfIdeasActions.getIdeasUserStepFlux(
          paging.page,
          paging.sort,
          paging.query,
          paging.limit,
          ideasStepsFlux.map(({ _id }) => _id)
        ));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingCreateIdea(false);
    }
  }

  async function createDraft() {
    try {
      setLoadingCreateIdea(true);

      if (ideaCreate?.challenge?.notChallenge) {
        delete ideaCreate.challenge;
      }

      await dispatch(ideaCreateActions.createDraft({
        ...ideaCreate,
        businessUnitLocal: fields.map(field => field.selectedBusinessUnit),
        estimatedFinancialReturn: unMaskCurrency(ideaCreate?.estimatedFinancialReturn),
        estimatedExecutionCost: unMaskCurrency(ideaCreate?.estimatedExecutionCost)
      }, t('ideia_salva_em_rascunhos')));
      
      dispatch(ideaCreateActions.clearAll());
      dispatch(ideaCreateActions.clearClassification());

      if (location.pathname.includes('general')) {
        dispatch(fluxOfIdeasActions.getIdeaInFlux(id));
      } else if (location.pathname.includes('my-ideas')) {
        dispatch(fluxOfIdeasActions.getIdeasUserStepFlux(
          paging.page,
          paging.sort,
          paging.query,
          paging.limit,
          ideasStepsFlux.map(({ _id }) => _id)
        ));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingCreateIdea(false);
    }
  }

  function redirectToEditTitle() {
    dispatch(ideaCreateDialogsActions.openDialogTitleDescription(!isSendIdeaDialog && 'sendIdea'));
  }

  function redirectToEditArea() {
    dispatch(ideaCreateDialogsActions.openDialogMultiArea(!isSendIdeaDialog && 'sendIdea'));
  }

  function redirectToEditChallenge() {
    dispatch(ideaCreateDialogsActions.openDialogChallenge(!isSendIdeaDialog && 'sendIdea'));
  }

  // function redirectToEditAmbit() {
  //   dispatch(ideaCreateDialogsActions.openDialogAmbit(!isSendIdeaDialog && 'sendIdea'));
  // }

  // function redirectToEditRadical() {
  //   dispatch(ideaCreateDialogsActions.openDialogRadical(!isSendIdeaDialog && 'sendIdea'));
  // }

  function redirectToEditClassification() {
    dispatch(ideaCreateDialogsActions.openDialogClassification(!isSendIdeaDialog && 'sendIdea'));
  }

  function redirectToEditLinks() {
    dispatch(ideaCreateDialogsActions.openDialogLink(!isSendIdeaDialog && 'sendIdea'));
  }
  
  function redirectToEditPhoto() {
    dispatch(ideaCreateDialogsActions.openDialogPhoto(!isSendIdeaDialog && 'sendIdea'));
  }

  function redirectToEditVideo() {
    dispatch(ideaCreateDialogsActions.openDialogVideo(!isSendIdeaDialog && 'sendIdea'));
  }

  function redirectToEditFile() {
    dispatch(ideaCreateDialogsActions.openDialogFile(!isSendIdeaDialog && 'sendIdea'));
  }

  function redirectToReviewIdea() {
    dispatch(ideaCreateDialogsActions.openDialogSendIdea());
  }

  function previous() {
    dispatch(ideaCreateDialogsActions.previousDialog());
  }

  function close() {
    if (width < config.RESPONSIVE_MOBILE) {
      dispatch(ideaCreateDialogsActions.openDialogClose());
    } else {
      dispatch(ideaCreateActions.clearAll());
      dispatch(ideaCreateDialogsActions.close());
    }
    dispatch(multiAreaCascadeActions.clearAll());
    dispatch(ideaCreateActions.clearAll());
    dispatch(ideaCreateActions.clearClassification());
  }
  
  return {
    ideaCreate,
    dialogSendIdea,
    loadingFlux,
    loading: ideaCreate.loading,
    isSendIdeaDialog,
    loadingCreateIdea,
    createIdea,
    createDraft,
    redirectToEditTitle,
    redirectToEditArea,
    redirectToEditChallenge,
    // redirectToEditAmbit,
    // redirectToEditRadical,
    redirectToEditClassification,
    redirectToEditPhoto,
    redirectToEditLinks,
    redirectToEditFile,
    redirectToEditVideo,
    redirectToReviewIdea,
    previous,
    close
  }
}